import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../../assets/Colors';

export const useStyles = makeStyles({
    container: {
        margin: 0,
        position: 'absolute',
        bottom: 20,
        left: '5vw',
        paddingLeft: 30,
        borderRadius: 30,
        border: '1px solid white',
        backgroundColor: '#00000066',
        minHeight: 40,
        width: '90vw',
        zIndex: 999,
    },
    desktopContainer: {
        margin: 0,
        paddingLeft: 30,
        borderRadius: 6,
        border: '1px solid white',
        backgroundColor: '#e9ecef',
        minHeight: 40,
        width: '100%',
        zIndex: 999,
    },
    desktopChatContainer: {
        marginTop: 20,
    },
    containerPaddingRight: {
        paddingRight: 60,
    },
    sendMessageIconButton: {
        width: 20,
        height: 20,
        padding: 20,
    },
    input: {
        color: 'white !important',
    },
    desktopInput: {
        alignItems: 'flex-start',
        padding: '10px 0px',
        color: '#495057 !important',
        maxHeight: 80,
        minHeight: 80,
        wordBreak: 'break-all',
        overflowY: 'auto',
    },
    textArea: {
        alignItems: 'flex-start',
    },
    sendMessageIcon: {
        width: 20,
    },
    reverse: {
        transform: 'rotateZ(180deg)',
    },
    text: {
        fontSize: 15,
        fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
        color: Colors.text.light,
        lineHeight: '1.2em',
    },
    instructionIcon: {
        width: 40,
        height: 40,
        padding: 5,
        border: '1px solid white',
        borderRadius: '50%',
    },
    textContainer: {
        margin: '5px 20px',
        width: '60%',
    },
    instructionTitle: {
        color: Colors.main.primary,
        fontSize: 18,
        marginBottom: 10,
    },
    instructionText: {},
    sendButton: {
        padding: '7px 40px',
        borderRadius: 30,
        textTransform: 'none',
        color: Colors.text.light,
        backgroundColor: 'rgb(144, 142, 153)',
    },
    sendButtonContainer: {
        marginTop: 20,
        paddingLeft: 10,
        paddingRight: 10,
    },
    maxMessageLength: {
        color: Colors.text.light,
    },
    errorColor: {
        color: Colors.text.error,
    },
});
